// extracted by mini-css-extract-plugin
export default {"AppRoot":"CommonLayout_AppRoot__fvnnJ","MainPage":"CommonLayout_MainPage__FcPez","mainPageChild":"CommonLayout_mainPageChild__UPBSq"};